var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { QuestionType } from "./question-type";
import { ListQuestion } from "app/shared/models/list-question";
var ChecklistQuestion = /** @class */ (function (_super) {
    __extends(ChecklistQuestion, _super);
    function ChecklistQuestion() {
        var _this = _super.call(this) || this;
        _this._answers = {};
        _this.type = QuestionType.Checklist;
        return _this;
    }
    ChecklistQuestion.prototype.addAnswer = function (label) {
        this._answers[label.id] = label;
    };
    ChecklistQuestion.prototype.removeAnswer = function (label) {
        if (this._answers.hasOwnProperty(label.id)) {
            delete this._answers[label.id];
        }
    };
    Object.defineProperty(ChecklistQuestion.prototype, "answerDisplayText", {
        get: function () {
            var description = this.getAnswerLabels()
                .reduce(function (prev, curr) { return prev + curr.label + " "; }, "");
            return description;
        },
        enumerable: true,
        configurable: true
    });
    ChecklistQuestion.prototype.hasAnswer = function (label) {
        return this._answers[label.id];
    };
    Object.defineProperty(ChecklistQuestion.prototype, "isFilledOut", {
        get: function () {
            // we let nothing be an option as well.
            // TODO: stephen we may at some point require at least one option to be checked...
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChecklistQuestion.prototype, "answerForSave", {
        get: function () {
            return Object.assign({}, this._answers); // just copy them over onto a new object
        },
        enumerable: true,
        configurable: true
    });
    ChecklistQuestion.prototype.setSavedAnswer = function (answer, labels) {
        var _this = this;
        Object.keys(answer).forEach(function (key) {
            var label = labels.find(function (l) { return l.id == key; });
            if (label) {
                _this.addAnswer(label);
            }
        });
    };
    ChecklistQuestion.prototype.getAnswerLabels = function () {
        var _this = this;
        return Object.keys(this._answers)
            .filter(function (a) { return _this._answers[a].label; })
            .map(function (a) { return _this._answers[a]; });
    };
    return ChecklistQuestion;
}(ListQuestion));
export { ChecklistQuestion };



// WEBPACK FOOTER //
// ./src/app/shared/models/checklist-question.ts.pre-build-optimizer.js